import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useFormSubmit } from "./useFormSubmit";
import { useTransformValues } from "./useTransformValues";
import { useAdaptedSurveyFields } from "./useAdaptedSurveyFields";

import { fetchSurveyFields } from "../slices/getSurveyFields";

import { sendForm } from "../slices/sendFormSlice";
import { clearForm } from "../slices/formSlice";

export const useSurveyCreateForm = () => {
    const dispatch = useDispatch();
    const formId = "surveyForm";
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.sendForm.loadingStatus);
    const error = useSelector((state) => state.sendForm.error);
    const reload = true;
    const { transformFormValues } = useTransformValues();

    useEffect(() => {
        dispatch(fetchSurveyFields({token}))
    }, [dispatch, token]);

    const adaptedFieldList = useAdaptedSurveyFields()
    const fields = adaptedFieldList.flatMap(category => category.fields);

    const { handleSubmit } = useFormSubmit({
        formId,
        onSubmit: async (formValues) => {
            const attributes = transformFormValues(formValues, fields);

            const body = {
                data: {
                    type: "survey",
                    attributes: attributes
                }
            };

            console.log("Отправляемые данные", body);

            const action = await dispatch(sendForm({url: "/surveys", body, token}));
            if (sendForm.fulfilled.match(action)) {
                dispatch(clearForm({formId}));
            } else {
                throw action.payload || action.error
            }
        },
        successMessage: "Успешно отправлено",
        fields,
        reload,
        error
    });

    return { formId, loadingStatus, handleSend: handleSubmit, adaptedFieldList }
}